/**
 * Command-bar open-state store.
 *
 * Cross-component UI slice per Claude Design Files README section 7
 * ("React useState + Zustand for cross-component slices"). The dialog
 * itself is keyboard-driven (Cmd-K to open, Esc to close) and also
 * triggered by the sidebar search button; both paths flip the same
 * `open` flag so the dialog logic stays single-source.
 *
 * M2 ships only the open/close machinery and the empty dialog (per
 * spec section 15.2 acceptance criterion "Cmd-K opens an empty command
 * bar dialog"). M12 fills the dialog with real filtering across tasks,
 * leads, and opportunities (spec section 15.12).
 */

import { create } from 'zustand';

interface CommandBarState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useCommandBar = create<CommandBarState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}));
